import React from 'react';
import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import { selectors } from './../ducks/related.duck';
import ArticleSummary from 'containers/ArticleSummary';
import SummaryList from 'components/general/SummaryList/SummaryList';
import MediaSkeleton from 'components/general/Media/MediaSkeleton';

const ArticleRelated = compose(
  withProps({
    renderItem: props => (
      <ArticleSummary
        {...props}
        small
        hide={['summary', 'image']}
      />
    ),
    renderSkeletonItem: () => (
      <MediaSkeleton image={false} />
    ),
  }),
  connect(state => ({
    items: selectors.data(state),
    loading: selectors.loading(state),
  })),
)(SummaryList);

export default ArticleRelated;
